/* Rquiere de mixin.js */

var typeBinding = {
	data () {
		return {
			listTypesBinding: [],
			methodsTypeBinding: {
				get: 'typesBinding',
				show: 'typeBinding/',
			},
			paginationTypesBinding: [],
			searchTypesBinding: '',
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getAllTypesBinding(page = 1) {
			let parameters = '?search=' + this.searchTypesBinding + '&page=' + page
			let url = this.getApiBackend + this.methodsTypeBinding.get + parameters
			this.axiosActionIS(url, 'GET', 'getAllTypesBindingResult')
        },
		getAllTypesBindingResult(response) {
            if(response.data.success) {
                this.listTypesBinding = response.data.data
                this.paginationTypesBinding = response.data.paginate    
            }
            this.getAllTypesBindingResultLocal(response)
		},
        getAllTypesBindingResultLocal(response) {
            console.log('getAllTypesBindingResultLocal no desarrollado', response)
        },
		getTypeBinding(id) {
			this.axiosActionIS(this.getApiBackend + this.methodsTypeBinding.show + id, 'GET', 'getTypeBindingResult')
		},
        getTypeBindingResult(response) {
            this.getTypeBindingResultLocal(response)
        },
        getTypeBindingResultLocal(response) {
            console.log('getTypeBindingResultLocal no está desarrollado', response)
        },
	},
};

export default typeBinding;